import type { BlockType } from '@unifyapps/defs/types/block';

export enum InterfaceModes {
  BUILDER = 'BUILDER',
  PREVIEW = 'PREVIEW',
  RUNNER = 'RUNNER',
}

export type InterfaceStoreRefType = {
  updateBlocks: ({
    added,
    deleted,
    changed,
  }: {
    added: BlockType[];
    deleted: BlockType[];
    changed: BlockType[];
  }) => void;
};

export enum InterfaceClient {
  // eslint-disable-next-line @typescript-eslint/naming-convention -- UA is short for UnifyApps
  UA_PLATFORM = 'UA_PLATFORM',
  // eslint-disable-next-line @typescript-eslint/naming-convention -- UA is short for UnifyApps
  UA_MATRIX = 'UA_MATRIX',
}
